import React from "react";
import { MainLayout } from "../layout/mainLayout";
import { PageTitle } from "../layout/pageTitle";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useTranslation } from "react-i18next";
import { FormControl, MenuItem, Select } from "@mui/material";
import i18next from "i18next";
import { changeDefaultCulture, DefaultCultureDto } from "../../services/employeeService";
import { useAppDispatch } from "../../framework/redux/hooks";
import { addSuccessMsg } from "../../framework/redux/slices/appSlice";
import { handleEasyOppApiError } from "../../services/baseService";
import { FormikProps, useFormik } from "formik";
import { defaultFormikConfig } from "../framework/formUtils";
import { LoadingButton } from "../framework/loadingButton";
import { cultureCodeEnglish, cultureCodeFinnish, cultureCodeSwedish } from "../../i18n/i18n";

export const Language = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleSubmit = (formData: DefaultCultureDto, { setSubmitting }) => {
        changeDefaultCulture(formData)
            .then(() => {
                i18next.changeLanguage(formData.defaultCulture);
                dispatch(addSuccessMsg(t("settings.language.languageChangedSuccessfully")));
            })
            .catch(handleEasyOppApiError)
            .finally(() => setSubmitting(false));
    };

    const formik: FormikProps<DefaultCultureDto> = useFormik({
        ...defaultFormikConfig,
        initialValues: {
            defaultCulture: i18next.resolvedLanguage,
        },
        onSubmit: handleSubmit,
    });

    return (
        <MainLayout
            topComponent={
                <PageTitle header={t("settings.language.language")} />
            }
            hasPx
        >
            <form onSubmit={formik.handleSubmit}>
                <Grid2 container gap={2}>
                    <FormControl fullWidth>
                        <Select
                            value={formik.values.defaultCulture}
                            name={"defaultCulture"}
                            onChange={formik.handleChange}
                        >
                            <MenuItem value={cultureCodeFinnish}>{t("settings.language.finnish")}</MenuItem>
                            <MenuItem value={cultureCodeEnglish}>{t("settings.language.english")}</MenuItem>
                            <MenuItem value={cultureCodeSwedish}>{t("settings.language.swedish")}</MenuItem>
                        </Select>
                    </FormControl>
                    <Grid2 xs={12} display="flex" justifyContent="center">
                        <LoadingButton type="submit" variant="contained" fullWidth loading={formik.isSubmitting}>
                            {t("settings.language.setLanguage")}
                        </LoadingButton>
                    </Grid2>
                </Grid2>
            </form>
        </MainLayout>
    );
};